<template>
  <div>
    <div class="row1">
		<div id="">
			
		</div>
     <div class="dis-flex">
        <el-input
          size="small"
          clearable
          placeholder="搜索审批编号或名称"
          prefix-icon="el-icon-search"
          v-model="searchVal"
        >
        </el-input>
        <el-button
          @click="onSearch"
          class="row-btn add search"
          type="primary"
          size="small"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="tab-box">
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection"> </el-table-column> -->
        <el-table-column label="序号" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="审批名称">
			<template slot-scope="scope">{{ scope.row.approval.name }}</template>
		</el-table-column>
        <el-table-column label="状态" >
			<template slot-scope="scope">{{ scope.row.approval.status.text }}</template>
		</el-table-column>
        <el-table-column label="审批编号"> 
			<template slot-scope="scope">{{ scope.row.approval.number }}</template>
		</el-table-column>
        <el-table-column prop="create_time" label="提交时间"> 
			<template slot-scope="scope">{{ scope.row.approval.create_time }}</template>
		</el-table-column>
		<el-table-column label="审批时间">
			<template slot-scope="scope">{{ scope.row.approval.update_time }}</template>
		</el-table-column>
		<el-table-column label="流程" width="280">
			<template slot-scope="scope">
				<div class="steps-box">
					<el-steps direction="vertical" :active="scope.row.approval.level">
						<el-step :status="v.status.value == 2?'error': v.status.value == 0?'wait':''" :title="`${v.user.name}  ${v.update_time}`" v-for="(v,k) in scope.row.approval.logs">
							<template slot="description" v-if="v.speak">
								<span style="cursor: pointer;" @click="lookSpeak(v.speak)">查看留言</span>
							</template>
						</el-step>
					</el-steps>
				</div>
			</template>
		</el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div class="handle-box">
			  <span v-if="scope.row.approval.bind_detail" @click="onRelation(scope.row.approval.bind_detail)" class="txt-btn txtC">关联信息</span>
              <span class="txt-btn txtC" @click="approvalOperate(scope.row,1)">通过</span>
			  <span class="txt-btn txtC del-txt" @click="approvalOperate(scope.row,2)">驳回</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<el-dialog :title="operation" :visible.sync="dialogFormVisible" width="30%">
	  <el-form>
	    <el-form-item label-width="">
	      <el-input v-model="speak" type="textarea" :rows="2" placeholder="请在此说明通过或驳回的理由"></el-input>
	    </el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button class="small-btn btn-bor" size="small" @click="dialogFormVisible = false">取 消</el-button>
	    <el-button class="small-btn bgC" type="primary" @click="submit">确 定</el-button>
	  </div>
	</el-dialog>
	<el-dialog title="查看留言" :visible.sync="dialogSpeak" width="30%">
	  <el-form>
	    <el-form-item label-width="">
	      <el-input readonly v-model="speaks" type="textarea" :rows="2"></el-input>
	    </el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button class="small-btn bgC" type="primary" @click="dialogSpeak = false">关 闭</el-button>
	  </div>
	</el-dialog>
	<!-- 查看更多弹框 -->
	<!-- <offer-more :tableData="moreTabData" ref="moreDialog"></offer-more> -->
  </div>
</template>

<script>
	// import offerMore from "../../components/dialog/order/offer.vue";
export default {
	components: {
	  // offerMore,
	},
  data() {
    return {
		dialogSpeak:false,
		speaks:'',
		log_id:'',//审批log_id
		status:'',//审批状态
		operation:'',
		speak:'',//审批留言
		dialogFormVisible:false,
		moreTabData:[],
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
    this.getList();
  },
  methods: {
	  // 查看关联
	  onRelation(item){
		  // console.log(item);
		  this.$router.push({ path: item.url.admin,query:{id:item.id}});
	  },
	  //操作：通过/驳回弹框
	  approvalOperate(item,e){
		  if(e == 1){
			  this.operation = '确认通过'
		  }else{
			  this.operation = '确认驳回'
		  }
		  this.log_id = item.id;
		  this.status = e
		this.dialogFormVisible = true;  
	  },
	  //查看留言
	  lookSpeak(item){
		  this.speaks = item
		  this.dialogSpeak = true;
	  },
    //搜索
    onSearch(){
		this.pageObj.page = 1
		// this.pageObj.filter.brand = this.searchVal;
		this.pageObj.search = this.searchVal;
		// this.pageObj.op.brand = '%*%'
		// this.pageObj.op.search = '%*%'
		this.getList()
    },
	submit(id){
		if(!this.speak && this.status != 1)return this.$message.error('请输入驳回原因')
		let obj = {
			log_id:this.log_id,
			status:this.status,
			speak:this.speak
		}
		 this.$api2.approvalOperate(obj).then((res)=>{
			if(res.code == 1){
				this.dialogFormVisible = false
				this.$message.success(res.msg)
				this.getList()
			}else{
				this.$message.error(res.message)
			}
		 })
	},
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.approvalList(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
      		this.total = res.count;
      		this.tableData = res.data;
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-around;
}
// .el-steps{
// 	.el-step__head{
// 		.el-step__icon{
// 			width: 20px;
// 			height: 20px;
// 			font-size:12px;
// 		}
// 	}
	
// }
// </style>